"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Mission() {
  const stats = [{
    label: "Active Causes",
    value: "12"
  }, {
    label: "Community Members",
    value: "4.2k"
  }, {
    label: "Years of Advocacy",
    value: "05"
  }];
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="3851" id="why-4ever-fresh-exists" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        <div className="grid grid-cols-1 gap-10 md:gap-16 lg:grid-cols-12 lg:gap-20">
          {}
          <div ref={imageRef} className={`lg:col-span-7 lg:-ml-12 xl:-ml-20 transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative">
              <div className="relative overflow-hidden rounded-lg border border-border" style={{
              aspectRatio: "4/5"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717563/img/community_advocacy_gathering.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717563/img/community_advocacy_gathering.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717563/img/community_advocacy_gathering.png-wvc-sizes" alt="Community members gathering for a humanitarian awareness event" loading="lazy" decoding="async" className="h-full w-full object-cover" />
              </div>
              <p className="mt-5 italic text-sm text-muted-foreground" style={{
              fontFamily: "var(--font-serif)"
            }}>
                Forever Fresh Community Gathering · est. 2019
              </p>
            </div>
          </div>

          {}
          <div ref={contentRef} className={`lg:col-span-5 lg:pt-24 xl:pt-32 transition-all duration-1000 delay-200 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="mb-8 flex items-center gap-3">
              <span className="text-xs uppercase tracking-[0.25em] text-[var(--chart-4)]" style={{
              fontFamily: "var(--font-mono)"
            }}>
                N°01 — Our Mission
              </span>
            </div>

            {}
            <h2 className="font-default text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-foreground mb-10" style={{
            fontFamily: "var(--font-serif)",
            fontWeight: 400
          }}>
              Awareness,
              <br />
              <em className="italic text-[var(--chart-4)]" style={{
              fontWeight: 300
            }}>
                everlasting.
              </em>
            </h2>

            {}
            <div className="space-y-6 text-base md:text-lg leading-relaxed text-muted-foreground max-w-xl">
              <p>
                Forever Fresh exists to ensure that critical humanitarian issues remain at the forefront of public consciousness. We believe that awareness is the first step toward meaningful, lasting change.
              </p>
              <p>
                By blending purpose-driven advocacy with limited-edition apparel, we create a platform where your support directly funds the causes that matter most to our global community.
              </p>
            </div>

            {}
            <div className="mt-12 mb-10 border-t border-border">
              {stats.map((stat, i) => <div key={stat.label} data-index={i} className="flex items-baseline justify-between py-5 border-b border-border">
                  <span className="text-sm uppercase tracking-[0.2em] text-muted-foreground" style={{
                fontFamily: "var(--font-mono)"
              }}>
                    {stat.label}
                  </span>
                  <span className="text-3xl md:text-4xl text-foreground" style={{
                fontFamily: "var(--font-serif)",
                fontWeight: 400
              }}>
                    {stat.value}
                  </span>
                </div>)}
            </div>

            {}
            <Button asChild variant="ghost" className="h-auto px-0 py-2 text-sm uppercase tracking-[0.25em] text-foreground hover:bg-transparent hover:text-[var(--chart-4)] group">
              <Link to="/AboutImpactPage">
                <span style={{
                fontFamily: "var(--font-mono)"
              }}>Learn Our Impact</span>
                <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div aria-hidden="true" className="pointer-events-none absolute bottom-6 right-6 md:bottom-10 md:right-10 select-none" style={{
      opacity: 0.04
    }}>
        <span className="text-7xl md:text-9xl tracking-[0.2em] text-[var(--chart-4)]" style={{
        fontFamily: "var(--font-serif)",
        fontWeight: 500
      }}>
          fresh
        </span>
      </div>
    </section>;
}